import React, {useContext, useEffect, useState}from "react";
import { useHistory, useParams } from "react-router-dom";
import Button from "../../shared/components/formElements/Button";
import Avatar from "../../shared/components/UIElements/Avatar";
import Card from "../../shared/components/UIElements/Card";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import FloatingButton from "../../shared/components/UIElements/FloatingButton";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import Modal from "../../shared/components/UIElements/Modal";
import logo from "../../assets/logo/webscript.png";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from '../../shared/context/auth-context';
import { ITEM_TYPES } from "../../item/components/itemTypes";
import { v4 as uuidv4 } from 'uuid';
import "./ConsignmentInfo.css";
import { useWindow } from "../../shared/hooks/window-hook";
const ConsignmentInfo = () => {
  const {width} = useWindow()
  const auth = useContext(AuthContext);
  const history = useHistory();
  const [loadedConsignment, setloadedConsigment] = useState();
  const [showConfirmModal, setShowConfirmModal] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [isPrint, setIsPrint] = useState(true)
  const consignmentID= useParams().consignmentId;

  useEffect(() =>{
    const fetchConsignment = async () =>{
        try {
            const responseData = await sendRequest(
                process.env.REACT_APP_BACKEND_URL+`/consignments/${consignmentID}`,
                "GET",
                null,
                {Authorization: 'Bearer '+ auth.token}
            );
            setloadedConsigment(responseData.consignment);
        } catch (err) {}
    };
    fetchConsignment();
  },[sendRequest, consignmentID, auth.token]);


  const showWarningHandler = (task) =>{
    setShowConfirmModal(task);
  }

  const cancelWarningHandler =() =>{
    setShowConfirmModal("");
  }
  const confirmDeleteHandler = async () =>{
    setShowConfirmModal("");
    try {
        await sendRequest(process.env.REACT_APP_BACKEND_URL+`/consignments/${consignmentID}`,
         "DELETE",
         null,
         {Authorization: 'Bearer '+ auth.token}
        );
        history.push("/consignments");
    } catch (err) { }
  }

  const confirmMoveHandler = async () => {
    setShowConfirmModal("");
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+"/items/new",
        "POST",
        JSON.stringify({
          style: loadedConsignment.style + uuidv4(),
          company: loadedConsignment.company,
          color: loadedConsignment.color,
          USSize: loadedConsignment.USSize,
          EURSize: loadedConsignment.EURSize,
          quantity: loadedConsignment.quantity,
          cost: loadedConsignment.cost,
          price: loadedConsignment.price,
          website: loadedConsignment.website,
          type: ITEM_TYPES.CONSIGNMENT
        }),
        { "Content-Type": "application/json" ,
        Authorization: 'Bearer '+ auth.token}
      );
    } catch (err) { return; }
    try {
      await sendRequest(process.env.REACT_APP_BACKEND_URL+`/consignments/${consignmentID}`,
       "DELETE",
       null,
       {Authorization: 'Bearer '+ auth.token}
      );
    } catch (err) { return; }
    history.push("/orders/new");
  }

  const confirmReturnHandler = async () => {
    setShowConfirmModal("");
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+"/sendBacks/new",
        "POST",
        JSON.stringify({
          style: loadedConsignment.style,
          company: loadedConsignment.company,
          color: loadedConsignment.color,
          USSize: loadedConsignment.USSize,
          EURSize: loadedConsignment.EURSize,
          quantity: loadedConsignment.quantity,
          cost: loadedConsignment.cost,
          price: loadedConsignment.price,
          website: loadedConsignment.website,
          description: loadedConsignment.description,
          issueDate: new Date()
        }),
        { "Content-Type": "application/json" ,
        Authorization: 'Bearer '+ auth.token}
      );
    } 
    catch (err) { return; }
    try {
      await sendRequest(process.env.REACT_APP_BACKEND_URL+`/consignments/${consignmentID}`,
      "DELETE",
      null,
      {Authorization: 'Bearer '+ auth.token}
      );
      history.push("/sendBacks");
    } catch (err) { return; }
  }

  return (
    <React.Fragment>
        <ErrorModal error={error} onClear={clearError} />
        {isLoading && (<div className="center"><LoadingSpinner /></div>)}
        <Modal
        show={showConfirmModal}
        onCancel={cancelWarningHandler}
        header="Are you sure?"
        footerClass="items-item__modal-actions"
        footer={
          <React.Fragment>
            <Button inverse onClick={cancelWarningHandler}>
              CANCEL
            </Button>
            {
              showConfirmModal === "SALE" ? 
                <Button success onClick={confirmMoveHandler} >
                  SALE
                </Button> : showConfirmModal === "DELETE" ?
                <Button danger onClick={confirmDeleteHandler}>
                  DELETE
                </Button> :
                <Button secondary onClick={confirmReturnHandler}>
                  SEND BACK
                </Button> 
            }
          </React.Fragment>
        }
      >       
      <p>
          {`Do you want to proceed and ${showConfirmModal.toLowerCase()} 
          this item? Please note that it can't be undone thereafter.`}
      </p>
      </Modal>
      {!isLoading && loadedConsignment && (
        <li className="consignment-list">
          <Card className="consignment-item__content">
            <div className="container">
              <div className="row">
                <div className="col">
                  <form>
                    <div className="print-button">
                      {isPrint ? 
                    <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint);}}>                
                      PRINT
                    </Button> :
                    <Button inverse onClick={(e) => {e.preventDefault(); setIsPrint(!isPrint); window.print();setIsPrint(!isPrint);}}>                
                      🖨️
                    </Button>}
                    </div>
                    <br />
                    {isPrint && <h2 className="header-text">Consignment Details</h2>}

                    <div className="flex justify-center">
                      <div className=" w-50 mr1">
                        <label>Style</label>
                        <input readOnly type="text" value={loadedConsignment.style.split('_')[0]} />
                      </div>
                      <div className=" w-50  mr1">
                        <label>Company</label>
                        <input
                          readOnly
                          type="text"
                          value={loadedConsignment.company}
                        />
                      </div>
                    </div>
                    <div className="flex justify-center">
                      <div className=" w-50  mr1">
                        <label>Color</label>
                        <input readOnly type="text" value={loadedConsignment.color? loadedConsignment.color : "N/A"} />
                      </div>
                      <div className=" w-50  mr1">
                        <label>US Size</label>
                        <input readOnly type="text" value={loadedConsignment.USSize ? loadedConsignment.USSize : 1} />
                      </div>
                      <div className=" w-50  mr1">
                        <label>EUR Size</label>
                        <input
                          readOnly
                          type="text"
                          value={loadedConsignment.EURSize ? loadedConsignment.EURSize : 1}
                        />
                      </div>
                    </div>

                    <div className="flex justify-center">
                      <div className=" w-50  mr1">
                        <label>Quantity</label>
                        <input
                          readOnly
                          type="text"
                          value={loadedConsignment.quantity }
                        />
                      </div>
                      {isPrint && <div className=" w-50  mr1">
                      <label>Cost</label>
                      <input readOnly type="text" value={loadedConsignment.cost ? "$"+loadedConsignment.cost : "N/A"} />
                    </div>}

                      <div className=" w-50 mr1">
                        <label>Price</label>
                        <input readOnly type="text" value={loadedConsignment.price ? "$"+loadedConsignment.price : "N/A" } />
                      </div>
                    </div>
                    <div className="flex justify-left">
                      {  isPrint && <div className=" w-50 mr1">
                            <label>Website</label>
                            <input  readOnly type="text" value={loadedConsignment.website ? loadedConsignment.website : "N/A"}/>
                        </div>}
                        <div className=" w-50 mr1">
                            <label>Description</label>
                            <textarea readOnly value={loadedConsignment.description} />
                        </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="image-container">
              <div className="consignment-avatar">
                {loadedConsignment.website ? (
                  <img
                    src={loadedConsignment.website}
                    alt=""
                    width="auto"
                    height="auto"
                  />
                ) : (
                  <Avatar image={logo} />
                )}
              </div>
            </div>

            {isPrint && <div className="consignment-item__actions">
              <Button inverse to="/consignments">
                BACK
              </Button>
              <Button to={`/consignments/${consignmentID}/edit`}>
                EDIT
              </Button>
      {  width > 800 ? <Button success onClick={() => showWarningHandler("SALE")}>
                SALE
              </Button> : ""}
              <Button danger onClick={() => showWarningHandler("DELETE")}>
                DELETE
              </Button>
              <Button secondary onClick={() => showWarningHandler("SEND BACK")}>
                SEND BACK
              </Button>
            </div>}
          </Card>
        </li>
      )}
      {isPrint && <FloatingButton icon={"back"} />}
    </React.Fragment>
  );
};

export default ConsignmentInfo;
